export enum AiRequestStatus {
    NeedMoreInfo = 'Need More Info',
}
